import React, { Component } from "react";

class Button extends Component {
  render() {
    const {
      children,
      disabled,
      color,
      float,
      className,
      onClick,
      type,
    } = this.props;
    const classes = ["btn", `btn-${color || "default"}`];

    if (float) {
      classes.push(`pull-xs-${float}`);
    }

    if (className) {
      classes.push(className);
    }

    return (
      <button
        className={classes.join(" ")}
        disabled={disabled}
        onClick={onClick}
        type={type ? type : "button"}
      >
        {children}
      </button>
    );
  }
}

export default Button;
